export default "__VITE_ASSET__B1m8NARv__"